import { createFileRoute } from "@tanstack/react-router";
import { SettingsPageShell } from "@/features/settings";

function SecuritySettingsPage() {
  return (
    <SettingsPageShell
      title="Security"
      description="Password and multi-factor authentication controls will be added in a later phase."
    />
  );
}

export const Route = createFileRoute("/settings/security")({
  component: SecuritySettingsPage,
});
